import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  connect() {
    this.beforeCache = () => Modal.getInstance(this.element)?.hide()
    document.addEventListener("turbo:before-cache", this.beforeCache)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.beforeCache)
    const modal = Modal.getInstance(this.element)
    modal?.hide()
    modal?.dispose()
  }

  close() { Modal.getInstance(this.element)?.hide() }
}
